module.exports = __webpack_public_path__ + "assets/03becc03d14001739325d645a12d0e11.png";